import script from "./LeagueProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeagueProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./LeagueProgressBar.vue?vue&type=style&index=0&id=16df80a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16df80a2"]])

export default __exports__